import React from 'react';
import TabTransferToBankByBIDVFeature from './TabTransferToBankByBIDV';

const BalanceTransferToBankByBIDVFeature = (): JSX.Element => {
  return (
    <>
      <TabTransferToBankByBIDVFeature />
    </>
  );
};

export default BalanceTransferToBankByBIDVFeature;
